<template>
  <section role="modal">
    <div
      class="modal fade"
      id="regraFeriasPendentesModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="regraFeriasPendentesModalLabel"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title" id="regraFeriasPendentesModalLabel">
              Férias Anteriores Pendentes
            </h4>
          </div>
          <div class="modal-body">
            <div class="row row-field" style="padding-bottom: 15px">
              <div class="col-md-12 col-sm-12">
                <p>Você tem férias pendentes de exercícios anteriores!</p>
                <p>
                  Conforme § 3º do artigo 172 da Lei nº 4623/84, é proibida a
                  acumulação de férias pelo máximo de dois anos consecutivos.
                </p>
                <p>
                  Para regularizar sua situação é necessário enviar memorando
                  por e-mail para o endereço
                  <a href="mailto:ferias@santos.sp.gov.br">
                    ferias@santos.sp.gov.br </a
                  >, até o 3º dia útil do mês anterior ao do início das férias.
                </p>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <botao
              estilo="cheio-verde"
              rotulo="Ciente"
              icone="ok-modal"
              dismiss="modal"
            ></botao>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Botao from '@/components/botao';

export default {
  name: 'ExplicacaoModal',

  components: {
    Botao,
  },
};
</script>



// WEBPACK FOOTER //
// regra-ferias-pendentes-modal.vue?39606906